import React from "react";

const Partner=(props)=> {
    return(
        <>
        <div className="Partner-container">
            <img src={props.img} alt="" />
            <h3>{props.partner}</h3>
            <button>Explore</button>
        </div>
        
        </>
    );
}

export default Partner ;